import { EstacaoTempoChuva } from "../grupo-chuva-estacao";

export  abstract class TimeComparator {

    lastYear: number;
    lastMonth: number;
    lastDay: number;
    lastHour: number;
    lastMinute: number;
    lastStationName: string;
    timeSum: number = 0;

    /**
     * Verifica se o registro pertence ao intervalo de tempo que está sendo contabilizado no momento.
     * @param time registro de tempo atual
     * @returns true se o tempo ainda está no intervalo contrário, false caso contrário
     */
    onSameInterval(time: EstacaoTempoChuva): boolean {

        if (! this._sameStation(time) ) {
            this.lastStationName = time.nome_estacao_original;
            this.timeSum = 0;
            this._setLastTimeValues(time);
            return false;
        }

        this._addTimeInMillis(time);
        this._setLastTimeValues(time);

        if (this.isOnInterval()) {
            return true;
        }

        this.timeSum = 0;
        return false;
    }

    /**
     * Define o valor do tempo acumulado em milissegundos
     * @param sum tempo acumulado
     */
    private _setTimeSum(sum: number) {
        this.timeSum = sum;
    }

    /**
     * 
     * @param time 
     */
    private _addTimeInMillis(time: EstacaoTempoChuva) {
        let lastDate = new Date(this.lastYear, this.lastMonth - 1, this.lastDay, this.lastHour, this.lastMinute);
        let currentDate = new Date(time.ano, time.mes - 1, time.dia, time.hora, time.minuto);

        let diff = currentDate.valueOf() - lastDate.valueOf();

        this.timeSum += diff;
    }

    /**
     * Verifica se o registro de tempo tem o mesmo nome da estação que está armazenada.
     * @param time registro de tempo que possui o nome da estação 
     * @returns true se o nome da estação é o mesmo, false caso contrário
     */
    private _sameStation(time: EstacaoTempoChuva) {
        return this.lastStationName == time.nome_estacao_original;
    }

    /**
     * 
     * @param time 
     */
    private _setLastTimeValues(time: EstacaoTempoChuva) {
        this.lastYear = time.ano;
        this.lastMonth = time.mes;
        this.lastDay = time.dia;
        this.lastHour = time.hora;
        this.lastMinute = time.minuto;
    }

    /**
     * Verifica se o tempo acumulado ainda está no intervalo de duração específico.
     */
    abstract isOnInterval(): boolean;
}